"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType["BASIC"] = "basic";
    OrderType["ENGLISH"] = "english";
    OrderType["CRITERIA"] = "criteria";
})(OrderType || (exports.OrderType = OrderType = {}));
//# sourceMappingURL=types.js.map